import { render, staticRenderFns } from "./LeftUser.vue?vue&type=template&id=bf8488e8&scoped=true&"
import script from "./LeftUser.vue?vue&type=script&lang=js&"
export * from "./LeftUser.vue?vue&type=script&lang=js&"
import style0 from "./LeftUser.vue?vue&type=style&index=0&id=bf8488e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8488e8",
  null
  
)

export default component.exports